import { Media, MediaBody, MediaRight } from 'foundations-components/transitional/components/Media';
import ApprovalButtons from '../consumer/ApprovalButtons';
import ApprovalStatusTag from '../common/ApprovalStatusTag';
import { ApprovalTypes } from '../../types';
import ApprovalSummary from './ApprovalSummary';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ApprovalDueDate } from './ApprovalDueDate';
import { View } from 'foundations-components/components/View';
import { DescriptionList } from 'foundations-components/transitional/components/DescriptionList';
import FormattedDate from './FormattedDate';
import ApprovalUserFormattedName from '../ApprovalUserFormattedName';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ApprovalSidebarRequestDetails = ({
  approvalType,
  approvalStatus,
  approvalButtonProps
}) => {
  const approval = useApprovalContext();
  if (!approval.data) {
    return null;
  }
  return /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: "400",
    children: [/*#__PURE__*/_jsxs(Media, {
      children: [/*#__PURE__*/_jsx(MediaBody, {
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsxs(Flex, {
          gap: "200",
          marginBlockStart: "100",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h5",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "productApprovals.ApprovalSidebar.approvalDetailsTitle"
            })
          }), approvalStatus && /*#__PURE__*/_jsx(ApprovalStatusTag, {
            approvalStatus: approvalStatus
          })]
        })
      }), /*#__PURE__*/_jsx(MediaRight, {
        children: approvalType !== ApprovalTypes.DEAL && /*#__PURE__*/_jsx(ApprovalButtons, Object.assign({}, approvalButtonProps, {
          buttonProps: {
            size: 'sm'
          },
          primaryButtonUse: "primary",
          secondaryButtonUse: "secondary",
          hidePendingButton: true
        }))
      })]
    }), /*#__PURE__*/_jsx(ApprovalDueDate, {}), /*#__PURE__*/_jsxs(DescriptionList, {
      marginBlock: "500",
      children: [/*#__PURE__*/_jsx("dt", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalSidebar.requestedBy"
        })
      }), /*#__PURE__*/_jsx("dd", {
        children: /*#__PURE__*/_jsx(ApprovalUserFormattedName, {
          approvalUser: approval.data.requester
        })
      }), /*#__PURE__*/_jsx("dt", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalSidebar.requestedDate"
        })
      }), /*#__PURE__*/_jsx("dd", {
        children: /*#__PURE__*/_jsx(FormattedDate, {
          date: approval.data.createDateTimestamp
        })
      })]
    }), /*#__PURE__*/_jsx(ApprovalSummary, {})]
  });
};